import moment from "moment";
import MDBox from "components/MDBox";
import Author from "components/Table/Author";
import Status from "components/Table/Status";
import By from "components/Table/By";
import { Tooltip } from "@mui/material";

import Constants, { Icons, defaultData } from "utils/Constants";
import { getFormattedCallingFirstName, getFormattedProjectName } from "utils/methods/methods";

const SNAG_DETAILS_PREVIEW_LENGTH = 60;

const MS_PER_DAY = 24 * 60 * 60 * 1000;

// Older snags store dateAdded as a calendar date (UTC midnight) - read it in UTC to avoid day
// shifts. Newer snags store the creation timestamp - read it in the user's local time.
export const getSnagDateMoment = (date) =>
  new Date(date).getTime() % MS_PER_DAY === 0 ? moment.utc(date) : moment(date);

export const formatSnagDate = (date) =>
  date ? getSnagDateMoment(date).format(defaultData.WEB_DATE_FORMAT_WITH_SLASH) : Constants.NA;

export const formatSnagStatus = (status) => (status ? status.replace(/_/g, " ") : "");

export default function SnagData(snagList, handleView, handleEdit, handleDelete, permission) {
  const rows =
    snagList?.map((item, index) => ({
      srNo: <Author name={index + 1} />,
      project: <Author name={getFormattedProjectName(item?.project)} />,
      location: <Author name={item?.location?.title} />,
      dateCreated: <Author name={formatSnagDate(item?.dateAdded)} />,
      details:
        item?.details?.length > SNAG_DETAILS_PREVIEW_LENGTH ? (
          <Tooltip title={item.details}>
            <span>
              <Author
                name={`${item.details.slice(0, SNAG_DETAILS_PREVIEW_LENGTH)}...`}
                style={{ textTransform: "none" }}
              />
            </span>
          </Tooltip>
        ) : (
          <Author name={item?.details} style={{ textTransform: "none" }} />
        ),
      status: <Status title={formatSnagStatus(item?.status)} />,
      createdBy: (
        <By
          name={getFormattedCallingFirstName(item?.createdBy)}
          when={moment(item?.createdAt).format(defaultData.WEB_DATE_FORMAT)}
        />
      ),
      action: (
        <MDBox>
          <Tooltip title="View">
            <span>
              <MDBox component="span" onClick={() => handleView(item)} sx={{ cursor: "pointer" }}>
                {Icons.VIEW}
              </MDBox>
            </span>
          </Tooltip>
          &nbsp;
          {permission?.update && (
            <>
              <Tooltip title="Edit">
                <span>
                  <MDBox
                    component="span"
                    onClick={() => handleEdit(item)}
                    sx={{ cursor: "pointer" }}
                  >
                    {Icons.EDIT}
                  </MDBox>
                </span>
              </Tooltip>
              &nbsp;
            </>
          )}
          {permission?.delete && (
            <Tooltip title="Delete">
              <span>
                <MDBox
                  component="span"
                  onClick={() => handleDelete(item[Constants.MONGOOSE_ID])}
                  sx={{ cursor: "pointer" }}
                >
                  {Icons.DELETE}
                </MDBox>
              </span>
            </Tooltip>
          )}
        </MDBox>
      ),
    })) || [];

  return {
    snagColumns: [
      { Header: "No.", accessor: "srNo", width: "4%" },
      { Header: "Project", accessor: "project", align: "left", width: "14%" },
      { Header: "Location", accessor: "location", align: "left", width: "12%" },
      { Header: "Date Created", accessor: "dateCreated", align: "left", width: "10%" },
      { Header: "Details", accessor: "details", align: "left", width: "28%" },
      { Header: "Status", accessor: "status", align: "left", width: "10%" },
      { Header: "Created By", accessor: "createdBy", align: "left", width: "12%" },
      { Header: "Action", accessor: "action", align: "center", width: "10%" },
    ],
    snagRows: rows,
  };
}
